import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Gamepad from '../../GamePad';
import Ps4Layout from '../../GamePad/layouts/PS4';
import ArrowsBackground from '../Ps4Share/ArrowsBackground';
import ArrowsBorder from '../Ps4Share/ArrowsBorder';
import ButtonsBackground from '../Ps4Share/ButtonsBackground';
import DownArrow from '../Ps4Share/DownArrow';
import L1Button from '../Ps4Share/L1Button';
import L2Button from '../Ps4Share/L2Button';
import LeftArrow from '../Ps4Share/LeftArrow';
import LeftLegBorder from '../Ps4Share/LeftLegBorder';
import LeftStick from '../Ps4Share/LeftStick';
import LeftStickBackground from '../Ps4Share/LeftStickBackground';
import LeftStickBorder from '../Ps4Share/LeftStickBorder';
import OButton from '../Ps4Share/OButton';
import OptionsButton from '../Ps4Share/OptionsButton';
import PsButton from '../Ps4Share/PsButton';
import R1Button from '../Ps4Share/R1Button';
import R2Button from '../Ps4Share/R2Button';
import RightArrow from '../Ps4Share/RightArrow';
import RightLegBorder from '../Ps4Share/RightLegBorder';
import RightStick from '../Ps4Share/RightStick';
import RightStickBackground from '../Ps4Share/RightStickBackground';
import RightStickBorder from '../Ps4Share/RightStickBorder';
import Speaker from '../Ps4Share/Speaker';
import ShareButton from '../Ps4Share/ShareButton';
import SquareButton from '../Ps4Share/SquareButton';
import TouchPad from '../Ps4Share/TouchPad';
import TriangleButton from '../Ps4Share/TriangleButton';
import UpArrow from '../Ps4Share/UpArrow';
import XButton from '../Ps4Share/XButton';

import Body from './components/Body';

const STICK_OFFSET = 30;

function ControllerPs4Pampling({ data, styles }) {
  const [gamepad, setGamepad] = useState({
    ...Ps4Layout.buttonsDefault,
    ...Ps4Layout.axisDefault,
  });
  const { player } = data;

  const axisChangeHandler = (axisName, value) => {
    setGamepad((prevState) => ({ ...prevState, [axisName]: value }));
  };
  const buttonChangeHandler = (buttonName, value) => {
    setGamepad((prevState) => ({ ...prevState, [buttonName]: value }));
  };

  return (
    <>
      <Gamepad
        gamepadIndex={player}
        layout={Ps4Layout}
        onButtonChange={buttonChangeHandler}
        onAxisChange={axisChangeHandler}
      >
        <svg
          width="800"
          height="600"
          viewBox="0 0 800 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <R2Button
            activeColor={styles.active.color}
            color={styles.backButtons.background}
            value={gamepad.RightTrigger}
          />
          <R1Button
            active={gamepad.R1}
            activeColor={styles.active.color}
            color={styles.backButtons.background}
          />
          <L1Button
            active={gamepad.L1}
            activeColor={styles.active.color}
            color={styles.backButtons.background}
          />
          <L2Button
            activeColor={styles.active.color}
            color={styles.backButtons.background}
            value={gamepad.LeftTrigger}
          />
          <Body />
          <LeftLegBorder color={styles.legs.background} />
          <RightLegBorder color={styles.legs.background} />
          <ArrowsBackground color={styles.arrows.background} opacity={0.7} />
          <ButtonsBackground color={styles.buttons.background} opacity={0.7} />
          <LeftStickBackground color={styles.sticks.background} opacity={0.7} />
          <g
            style={{
              transform: `translateX(${
                gamepad.LeftStickX * STICK_OFFSET
              }px) translateY(${-gamepad.LeftStickY * STICK_OFFSET}px)`,
            }}
          >
            <LeftStickBorder
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <LeftStick
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <RightStickBackground
            color={styles.sticks.background}
            opacity={0.7}
          />
          <g
            style={{
              transform: `translateX(${
                gamepad.RightStickX * STICK_OFFSET
              }px) translateY(${-gamepad.RightStickY * STICK_OFFSET}px)`,
            }}
          >
            <RightStickBorder
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <RightStick
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <TriangleButton
            active={gamepad.Triangle}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <OButton
            active={gamepad.O}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <XButton
            active={gamepad.X}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <SquareButton
            active={gamepad.Square}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <UpArrow
            active={gamepad.UpArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <RightArrow
            active={gamepad.RightArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <LeftArrow
            active={gamepad.LeftArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <DownArrow
            active={gamepad.DownArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <ArrowsBorder color={styles.arrows.border} />
          <PsButton
            active={gamepad.Ps}
            activeColor={styles.active.color}
            background={styles.ps.background}
            color={styles.ps.color}
          />
          <Speaker />
          <TouchPad
            active={gamepad.TouchPad}
            activeColor={styles.active.color}
            color={styles.touchpad.background}
          />
          <OptionsButton
            active={gamepad.Options}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <ShareButton
            active={gamepad.Share}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <path
            d="M424.883 151.092C423.386 151.471 421.699 153.101 420.429 155.356C419.026 157.896 415.955 166.273 414.382 171.808C413.624 174.499 413.377 175.011 412.202 176.129L411.52 176.792L411.671 175.939C412.089 173.627 411.558 171.675 410.079 170.159C408.961 169.003 407.956 168.642 405.947 168.661C404.165 168.661 402.838 168.984 400.943 169.799C400.393 170.045 399.9 170.253 399.863 170.253C399.825 170.253 399.787 170.026 399.787 169.723C399.787 168.131 397.133 167.05 395.332 167.903C394.991 168.055 394.65 168.339 394.574 168.51C394.498 168.68 393.57 171.391 392.489 174.518C391.409 177.645 390.48 180.337 390.423 180.507C390.271 180.867 386.765 184.089 386.518 184.089C386.348 184.089 386.594 183.123 387.712 179.541C389.324 174.423 389.362 172.13 387.921 170.045C387.314 169.154 385.457 167.884 384.376 167.581C382.974 167.202 382.708 167.467 379.524 172.225C377.932 174.575 376.624 176.508 376.586 176.508C376.548 176.508 376.586 176.186 376.681 175.788C376.946 174.613 376.87 172.3 376.529 171.296C376.112 170.064 374.728 168.68 373.155 167.96C371.032 166.956 370.805 167.145 367.393 172.3C366.199 174.101 365.194 175.541 365.156 175.504C365.099 175.428 365.838 171.959 366.312 170.159C366.578 169.135 366.578 169.078 366.18 168.718C365.952 168.51 365.175 167.979 364.474 167.543C362.976 166.671 362.18 166.558 361.668 167.183C361.327 167.638 360.019 171.41 359.034 174.897C358.048 178.366 355.849 182.478 354.276 183.786C353.726 184.26 353.65 184.279 353.48 183.995C353.196 183.483 353.48 182.232 355.186 176.319C357.422 168.586 357.309 169.135 356.778 168.718C356.247 168.282 354.655 167.79 353.802 167.79C352.76 167.79 352.21 168.112 351.888 168.889L351.603 169.609H348.646C346.106 169.59 345.443 169.666 344.173 170.026C341.254 170.86 339.017 172.13 335.302 175.011C334.241 175.826 333.369 176.489 333.331 176.451C333.312 176.432 333.369 175.921 333.482 175.333C333.729 173.855 333.407 172.433 332.535 171.106C331.227 169.192 329.54 168.415 327.095 168.605C325.787 168.718 323.342 169.401 322.261 169.969C321.522 170.348 321.503 170.329 321.503 169.704C321.503 167.941 317.996 166.842 316.631 168.207C315.987 168.87 306.832 196.03 307.002 196.826C307.268 198.02 309.542 198.987 311.059 198.532C311.457 198.399 311.893 198.191 312.006 198.039C312.139 197.887 312.992 195.708 313.921 193.187L315.589 188.6L317.731 188.619C322.147 188.676 323.891 187.861 331.492 182.175C333.426 180.716 335.037 179.56 335.075 179.597C335.113 179.616 334.999 180.033 334.847 180.488C333.994 182.914 333.767 185.966 334.316 187.558C334.847 189.093 336.477 190.155 338.335 190.155C340.287 190.155 343.263 188.676 345.898 186.383C346.77 185.644 347.49 185.037 347.528 185.037C347.585 185.037 347.661 185.435 347.737 185.928C348.002 187.88 349.196 188.998 351.205 189.169C352.665 189.302 353.973 188.619 355.944 186.686L357.574 185.132L357.441 186.004C357.328 186.819 357.347 186.913 357.877 187.368C358.541 187.918 361.574 189.681 362.199 189.851C362.559 189.965 362.863 189.567 365.118 185.757C367.677 181.436 370.558 176.887 370.729 176.887C370.786 176.887 370.767 177.039 370.71 177.209C370.388 178.043 369.459 183.18 369.459 184.146C369.459 186.061 369.762 186.876 370.805 187.691C371.866 188.525 373.724 189.681 374.292 189.851C374.634 189.946 374.994 189.434 377.192 185.738C379.619 181.626 382.633 176.887 382.803 176.887C382.841 176.887 382.765 177.342 382.614 177.873C382.026 180.071 381.59 182.857 381.59 184.336C381.609 186.61 382.045 187.444 383.959 188.714C384.907 189.34 385.798 189.34 386.878 188.733C387.333 188.468 387.731 188.278 387.769 188.316C387.807 188.354 387.239 190.173 386.518 192.353C385.59 195.101 385.21 196.466 385.305 196.826C385.552 198.02 387.826 198.968 389.343 198.532C389.741 198.399 390.177 198.191 390.29 198.039C390.423 197.887 391.276 195.708 392.205 193.187L393.873 188.6L395.939 188.619C398.365 188.657 400.109 188.316 402.27 187.406C404.677 186.364 407.843 184.487 410.402 182.592C411.179 182.005 411.975 181.417 412.183 181.265C412.524 181 412.543 181.057 412.411 183.748L412.259 186.497L412.771 186.895C413.605 187.558 415.349 188.127 416.751 188.221C419.329 188.373 421.32 187.141 425.85 182.592C427.309 181.114 428.541 179.92 428.598 179.92C428.655 179.92 428.693 180.829 428.693 181.967C428.693 183.843 428.731 184.089 429.281 185.246C429.773 186.269 430.153 186.724 431.271 187.672C432.048 188.316 433.053 189.017 433.508 189.245C434.323 189.643 434.342 189.643 435.024 189.283C435.934 188.828 439.63 185.094 440.824 183.464C441.355 182.744 441.791 182.27 441.829 182.422C441.848 182.573 441.658 183.578 441.393 184.658C440.805 187.141 440.805 187.312 441.45 187.937C442.018 188.487 445.032 190.344 445.354 190.344C445.468 190.344 446.454 188.752 447.553 186.8C451.591 179.522 454.756 174.31 454.491 175.371C452.444 183.255 452.254 186.099 453.676 187.501C454.491 188.316 455.723 189.15 456.765 189.605C457.505 189.946 457.713 189.965 458.32 189.756C459.286 189.453 459.95 188.979 461.409 187.558L462.66 186.345L462.907 186.913C463.039 187.236 463.418 187.747 463.76 188.051C465.598 189.662 468.593 189.245 472.005 186.932C473.332 186.023 473.313 185.947 472.46 188.354L471.986 189.681L470.337 190.723C466.243 193.282 462.148 196.75 460.613 198.93C458.926 201.337 458.964 203.062 460.746 204.104C461.959 204.824 464.196 205.222 465.655 204.976C468.176 204.559 470.564 202.796 472.574 199.897C473.427 198.646 476.763 192.505 477.028 191.652C477.085 191.481 477.786 190.913 478.601 190.382C480.743 188.979 485.861 184.62 487.889 182.478C488.875 181.455 490.297 179.654 491.074 178.517C492.287 176.679 492.438 176.375 492.173 176.186C491.699 175.826 490.486 175.712 489.652 175.939C488.799 176.167 488.496 176.451 486.695 178.707C486.032 179.56 484.781 180.962 483.909 181.834C482.127 183.616 479.341 185.89 479.246 185.625C479.208 185.53 480.004 183.293 481.028 180.64C483.188 174.992 483.738 173.305 484.439 170.462C484.932 168.434 484.932 168.339 484.61 167.979C483.814 167.107 480.857 166.501 480.099 167.069C479.928 167.202 479.663 167.657 479.511 168.074C479.379 168.491 479.151 168.813 479.056 168.794C474.337 167.752 470.091 168.889 466.982 172.035C465.902 173.115 465.409 173.836 464.423 175.75C463.305 177.93 463.039 178.29 461.201 180.109C460.101 181.227 458.926 182.327 458.566 182.554L457.94 183.009L458.073 182.365C458.149 182.005 458.585 180.526 459.04 179.067C460.613 174.082 460.803 171.883 459.817 169.95C459.002 168.32 456.633 166.652 455.154 166.652C454.225 166.652 453.391 167.581 450.87 171.467C449.733 173.21 448.766 174.575 448.728 174.461C448.672 174.253 449.259 171.789 449.847 169.874L450.226 168.642L449.695 168.225C448.975 167.638 446.928 166.842 446.151 166.842C445.639 166.842 445.354 167.012 444.634 167.79C443.895 168.586 437.962 176.413 435.744 179.56C435.024 180.564 435.024 180.583 435.157 179.92C435.214 179.56 435.896 177.588 436.673 175.541C437.431 173.513 438.189 171.315 438.341 170.67L438.606 169.495L438.057 169.116C437.166 168.472 433.356 166.842 432.749 166.842C432.674 166.842 431.612 168.093 430.399 169.609C425.907 175.219 420.865 180.943 419.614 181.853C419.026 182.27 418.818 182.346 418.609 182.156C418.306 181.91 418.325 181.663 419.159 177.551L419.727 174.708L422.798 171.58C424.485 169.855 426.437 167.676 427.12 166.747C430.892 161.649 432.294 157.668 431.309 154.807C430.551 152.551 427.063 150.542 424.883 151.092ZM428.503 156.967C428.674 157.991 428.011 159.886 426.854 161.63C425.888 163.108 421.32 167.979 421.111 167.752C420.959 167.6 422.21 164.264 423.215 162.198C424.163 160.189 425.641 157.725 426.741 156.266L427.518 155.223L427.954 155.754C428.2 156.057 428.447 156.607 428.503 156.967ZM476.801 172.547C477.275 172.68 477.502 172.85 477.502 173.078C477.502 173.798 474.488 179.446 473.313 180.924C471.436 183.274 469.143 184.544 468.593 183.54C467.759 181.948 469.636 176.963 472.062 174.291C473.616 172.585 475.057 172.054 476.801 172.547ZM349.329 173.457C349.537 173.57 349.48 173.855 349.082 174.821C347.301 179.029 344.798 182.63 342.751 183.938C341.14 184.942 340.401 184.544 340.439 182.668C340.439 181.227 340.761 180.052 341.652 178.214C342.581 176.224 344.59 174.101 345.955 173.608C346.884 173.286 348.931 173.191 349.329 173.457ZM326.545 174.442C327.341 175.314 326.791 177.134 325.028 179.484C324.005 180.848 322.792 181.796 321.086 182.554C319.607 183.218 317.333 183.976 317.219 183.843C317.162 183.786 317.598 182.232 318.205 180.375C319.039 177.721 319.38 176.887 319.778 176.565C322.185 174.499 325.635 173.438 326.545 174.442ZM404.772 174.366C405.246 174.897 405.322 175.617 405.037 176.47C404.298 178.612 402.175 181.114 400.261 182.137C398.991 182.801 395.655 184.014 395.503 183.843C395.446 183.786 395.882 182.232 396.489 180.375C397.645 176.736 397.626 176.736 399.465 175.541C401.455 174.234 404.108 173.646 404.772 174.366ZM469.579 196.769C468.593 199.082 468.138 199.726 467.039 200.276C465.921 200.844 465.409 200.901 465.257 200.484C465.105 200.105 466.091 198.589 467.209 197.527C468.157 196.618 469.958 195.253 470.072 195.367C470.11 195.405 469.882 196.03 469.579 196.769Z"
            fill="#0075CF"
          />
          <path
            d="M436.578 159.526C435.119 160.057 433.716 161.781 433.716 163.07C433.716 164.359 436.104 165.932 438.512 166.217C439.365 166.33 439.44 166.292 440.123 165.572C441.127 164.511 441.886 163.032 441.999 161.857C442.075 160.985 442.037 160.815 441.639 160.436C440.578 159.469 438.038 158.995 436.578 159.526Z"
            fill="#0075CF"
          />
        </svg>
      </Gamepad>
    </>
  );
}

ControllerPs4Pampling.propTypes = {
  data: PropTypes.shape({
    player: PropTypes.number,
  }),
  styles: PropTypes.shape({
    active: PropTypes.shape({
      color: PropTypes.string,
    }),
    arrows: PropTypes.shape({
      color: PropTypes.string,
      background: PropTypes.string,
      border: PropTypes.string,
    }),
    backButtons: PropTypes.shape({
      background: PropTypes.string,
    }),
    buttons: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    legs: PropTypes.shape({
      background: PropTypes.string,
    }),
    options: PropTypes.shape({
      background: PropTypes.string,
    }),
    ps: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    sticks: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    touchpad: PropTypes.shape({
      background: PropTypes.string,
    }),
  }),
};

ControllerPs4Pampling.defaultProps = {
  data: {
    player: 0,
  },
  styles: {
    active: {
      color: '#FF0000',
    },
    arrows: {
      color: '#0075CF',
      background: '#EBEBEB',
      border: '#0075CF',
    },
    backButtons: {
      background: '#0075CF',
    },
    buttons: {
      background: '#EBEBEB',
      color: '#0075CF',
    },
    legs: {
      background: '#0075CF',
    },
    options: {
      background: '#0075CF',
    },
    ps: {
      background: '#0075CF',
      color: '#F5F5F5',
    },
    sticks: {
      background: '#EBEBEB',
      border: '#0075CF',
      color: '#0364AF',
    },
    touchpad: {
      background: '#1A1B1F',
    },
  },
};

export default ControllerPs4Pampling;
